export const SIDE_NAV_WIDTH = 280;

export const VerticalLayoutRoot = ({ children }: { children: React.ReactNode }) => (
  <div className="tw:flex tw:flex-auto tw:max-w-full tw:min-[1200px]:pl-[280px]">{children}</div>
);

export const VerticalLayoutContainer = ({ children }: { children: React.ReactNode }) => (
  <div className="tw:flex tw:flex-auto tw:flex-col tw:w-full tw:overflow-x-clip tw:bg-background tw:text-foreground">
    {children}
  </div>
);
